module.exports = __webpack_public_path__ + "ac72bb9a7a7e8de76bd12847442e8a1a.pdf";